<script lang="ts">
  import Loading from '../../../etc/loader.svelte';
  import RepositoryFactory, { CONTRACT } from '../../../repositories/RepositoryFactory';
  import type { GetContractResult } from '../../../repositories/contract';
  import { loginUser } from '../../../components/auth/LoginUser';

  const contractRepository = RepositoryFactory[CONTRACT];
  let contract: GetContractResult,
    terminateReasonCode: string,
    terminateReasonDetail: string,
    pageStatus = 'INPUT',
    promise = getApi();
  let terminateDate: string;

  const terminateReasons = [
    { code: 'QUALITY', name: '品質' },
    { code: 'FEE', name: '料金' },
    { code: 'SUPPORT', name: 'サポート' },
    { code: 'OTHER', name: 'その他' }
  ];

  async function getApi() {
    const contractRepository = RepositoryFactory[CONTRACT];
    await contractRepository
      .getContract()
      .then((res) => {
        if (!res) {
          throw new Error();
        }
        contract = res;
      })
      .catch((error) => {
        displayErrorAlert(error.response.status);
      });
    return contract;
  }

  async function doPost() {
    await contractRepository
      .terminateContract({
        terminateTypeCode: 'APPLIED',
        terminateReasonCode: terminateReasonCode,
        terminateReasonDetail: terminateReasonDetail
      })
      .then((res) => {
        terminateDate = res.terminateDate;
        transisionWithdrawalComplete();
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('エラーが発生したため、解約できませんでした。');
        }
      });
  }

  function displayErrorAlert(status: number) {
    if (status === 403) {
      alert('セッションが切れました。再度ログインしてください。');
      loginUser.logout();
      location.reload();
    } else {
      alert('エラーが発生しました。再度やり直してください。');
    }
  }

  // 確認画面
  function onConfirm() {
    let errorMsg = '';
    if (!terminateReasonCode || !terminateReasons.filter((reason) => reason.code === terminateReasonCode)) {
      errorMsg += '解約理由を選択してください\n';
    }
    if (errorMsg) {
      alert(errorMsg);
      return;
    }
    pageStatus = 'CONFIRM';
  }
  // 入力画面
  function onBack() {
    pageStatus = 'INPUT';
  }
  function handleWithdrawalCompleteClose() {
    close();
    location.reload();
  }
  function transisionWithdrawalComplete() {
    pageStatus = 'COMPLETE';
  }
</script>

{#await promise}
  <Loading />
{:then contract}
  {#if pageStatus === 'INPUT'}
    <div class="shadow rounded bg-white border-t-4 border-green-400 mt-5">
      <div class="flex-1 m-5">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <span>ご契約いただいている以下内容を解約します。</span>
        </div>
      </div>
      <div class="flex-1 m-5">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <span>{contract.serviceName}</span>
        </div>
      </div>
      <div class="m-5">
        <span class="form-label-title font-semibold required">解約理由</span>
        <div class="flex space-x-4 w-full mt-1">
          {#each terminateReasons as reason}
            <label class="flex items-center">
              <input type="radio" name="terminateReason" value={reason.code} bind:group={terminateReasonCode} />
              <span class="text-sm">{reason.name}</span>
            </label>
          {/each}
        </div>
      </div>
      <div class="m-5">
        <div class="form-label-title font-semibold">解約理由詳細</div>
        <textarea style="border: 0.5px solid #000;" bind:value={terminateReasonDetail} />
      </div>
      <div class="flex-1">
        <div class="flex flex-col justify-items-center items-center">
          <div class="flex-1 m-5">
            <button class="button-primary" disabled={contract.contractStatusCode !== 'RUNNING'} on:click={onConfirm}>
              手続きへ
            </button>
          </div>
        </div>
      </div>
    </div>
  {:else if pageStatus === 'CONFIRM'}
    <div class="shadow rounded bg-white border-t-4 border-green-400 mt-5">
      <div class="flex-1 m-5">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <span>以下内容で解約します</span>
        </div>
      </div>
      <div class="flex-1 m-5">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <span>{contract.serviceName}</span>
        </div>
      </div>
      <div class="m-5">
        <span class="form-label-title font-semibold">解約理由</span>
        <div class="flex space-x-4 w-full mt-1">
          <div>
            {terminateReasons.filter((reason) => reason.code === terminateReasonCode)[0].name}
          </div>
        </div>
      </div>
      <div class="m-5">
        <div class="form-label-title font-semibold">解約理由詳細</div>
        <div>{terminateReasonDetail ?? '-'}</div>
      </div>
      <div class="flex-1 mt-8">
        <div class="flex flex-col justify-items-center items-center">
          <div class="flex-1 mb-5">
            <button on:click|once={onBack} class="button-primary"> 戻る </button>
            <button on:click|once={doPost} class="button-primary"> 完了 </button>
          </div>
        </div>
      </div>
    </div>
  {:else if pageStatus === 'COMPLETE'}<!-- 解約 完了-->
    <div class="shadow rounded bg-white border-t-2 border-green-400 mt-5">
      <div class="flex-1 m-5">
        <div class="mb:font-sm">ご利用ありがとうございました。</div>
        <div class="mb:font-sm mt-3">解約日：{terminateDate}</div>
      </div>
      <div class="flex-1 m-5">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <span class="mb:font-sm">マイページは解約後、一定期間過ぎると利用できなくなるためご注意ください。</span>
        </div>
      </div>

      <div class="flex flex-col justify-items-center items-center">
        <div class="flex-1 m-5">
          <button on:click|once={handleWithdrawalCompleteClose} class="button-primary"> 閉じる </button>
        </div>
      </div>
    </div>
  {/if}
{/await}

<style lang="postcss">
  .required:after {
    content: ' *';
    color: red;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-white focus:outline-none px-10 py-2;
  }
</style>
